'use strict';

var creditCardType = require('credit-card-type');

creditCardType.removeCard(creditCardType.types.MIR);

module.exports = creditCardType;



//////////////////
// WEBPACK FOOTER
// ./~/braintree-web-drop-in/~/braintree-web/hosted-fields/shared/get-card-types.js
// module id = 819
// module chunks = 0